/*
 * (c) Copyright, 2008-2015 Massachusetts Institute of Technology.
 *
 *     This material may be reproduced by or for the
 *     U.S. Government pursuant to the copyright license
 *     under the clause at DFARS 252.227-7013 (June, 1995).
 */
define(['ol', 'ext', 'hvx/modules/CoreModule', 'hvx/modules/Constants'], (ol, Ext, Core, Constants) => {
  const BasemapSelector = function(opt_options) {
    const options = opt_options || {};
    const basemapList = Constants.basemapList;
    
    const dropDown = document.createElement('div');
    dropDown.id = 'mapDropdown';
    dropDown.className = 'dropdown-content';

    for (let i=0; i < basemapList.length; i++) {
      const lbl = document.createElement('label');
      const card = document.createElement('div');
      card.className = 'card';
      const container = document.createElement('div');
      container.className = 'container';
      container.textContent = basemapList[i].title;
      const img = document.createElement('img');
      img.src = basemapList[i].src;
      img.title = basemapList[i].description;	
      const input = document.createElement('input');
      input.type = 'radio';
      input.value = basemapList[i].value;
      if (input.value === 'voyager-v2') {
        input.setAttribute('checked', true);
      }
      input.name = 'basemap';
      lbl.appendChild(input);
      lbl.appendChild(card);
      card.appendChild(img);
      card.appendChild(container);
      dropDown.appendChild(lbl);
      input.addEventListener('click', changeBasemap);
    }

    const mapBtn = document.createElement('button');
    mapBtn.className = 'mapBtn';
    mapBtn.textContent = 'Basemaps ';
    mapBtn.title = 'Layer Switcher';

    const caret = document.createElement('span');
    caret.innerHTML = '&#9650;';
    mapBtn.appendChild(caret);
		
    const wrapper = document.createElement('div');
    wrapper.className = 'basemap-layer-switcher ol-unselectable ol-control';
    wrapper.id = 'mapBtnWrapper';
    wrapper.appendChild(mapBtn);
    wrapper.appendChild(dropDown);

    function buildBaseMapUrl(value) {
      return value === 'satellite' || value === 'openstreetmap' ? `https://api.maptiler.com/maps/${value}/{z}/{x}/{y}.jpg?key=6KOrA36ako66e9qWcbz8` : 
        value === 'classic' ? `https://api.maptiler.com/maps/5d8c9251-70b3-4c3d-aabd-427e3df5230e/{z}/{x}/{y}.png?key=6KOrA36ako66e9qWcbz8` : 
          `https://api.maptiler.com/maps/${value}/{z}/{x}/{y}.png?key=6KOrA36ako66e9qWcbz8`;
    }

    function toggle(e) {
      document.getElementById('mapBtnWrapper').classList.toggle('click');
      document.getElementById('mapDropdown').classList.toggle('show');
      e.stopPropagation();
    }

    function changeBasemap() {
      // might be able to get rid of this and just use this.value
      const basemap = basemapList.find(obj => {
        return obj.value === this.value;
      });
      
      const url = buildBaseMapUrl(this.value);
      const layers = Core.Ext.Map.getMap().getLayers().getArray();
      for (let i = 0; i < layers.length; i++) {
        if (layers[i].get('name') === 'basemap') {
          const src = new ol.source.XYZ({
            url: url,
            tileSize: 512,
            crossOrigin: 'anonymous',
            attributions: '© MapTiler © OpenStreetMap contributors'
          });
          layers[i].setSource(src);
        }  
      }
      const ul = document.querySelector('.ol-attribution ul');
      if (this.value === 'satellite') {
        ul.classList.add('ol-attribution-dark-map');
      } else {
        ul.classList.remove('ol-attribution-dark-map');
      }

      // Classic HURREVAC basemap needs no attribution
      if (this.value === 'classic') {
        ul.classList.add('ol-attribution-none');
      } else {
        ul.classList.remove('ol-attribution-none');
      }
      Core.EventManager.fireEvent('change-basemap', basemap);
    }

    mapBtn.addEventListener('click', toggle);

    window.onclick = function() {
      document.getElementById('mapBtnWrapper').classList.remove('click');
      document.getElementById('mapDropdown').classList.remove('show');
    };

		
    ol.control.Control.call(this, {
      element : wrapper,
      target : options.target,
    });

  };
  //ol.inherits(BasemapSelector, ol.control.Control);
  BasemapSelector.prototype = Object.create(ol.control.Control.prototype);
  BasemapSelector.prototype.constructor = BasemapSelector;
	
  return BasemapSelector;
});
